export { default, type LabelProps } from './Label';
